import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { fadeUp } from "./motion";

const milestones = [
  { year: "2018", month: "Mayo", title: "Nace Rocky", text: "Fundada con la visión de escalar marcas deportivas emergentes en América Latina." },
  { year: "2018", month: "Noviembre", title: "Entramos al padel", text: "El primer vertical: la explosión del padel en la región comienza con nosotros." },
  { year: "2022", month: "Marzo", title: "Running gear", text: "Expansión al equipamiento de running, un mercado en pleno auge regional." },
  { year: "2023", month: "Junio", title: "Sunglasses + goodr", text: "Sumamos gafas deportivas al portafolio, incluyendo la marca goodr." },
  { year: "2025", month: "Hoy", title: "77 puertas retail", text: "+15.000 unidades vendidas y una red que sigue creciendo en 10+ mercados." },
];

const Timeline = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.7", "end 0.6"] });

  return (
    <section id="historia" className="py-24 lg:py-36 px-6 lg:px-12 bg-white border-y border-black/10" data-testid="timeline-section">
      <div className="max-w-[1600px] mx-auto">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="mb-16 lg:mb-24"
        >
          <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#DB2777]">Historia</span>
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-4">
            Siete años<br />en movimiento<span className="text-[#EAB308]">.</span>
          </h2>
        </motion.div>

        <div ref={ref} className="relative pl-8 lg:pl-0">
          <div className="absolute left-0 lg:left-1/2 top-0 bottom-0 w-px bg-black/10" />
          <motion.div
            style={{ scaleY: scrollYProgress }}
            className="absolute left-0 lg:left-1/2 top-0 bottom-0 w-px bg-[#DB2777] origin-top"
          />
          <div className="space-y-16 lg:space-y-24">
            {milestones.map((m, i) => (
              <motion.div
                key={`${m.year}-${m.title}`}
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-80px" }}
                className={`relative lg:w-1/2 ${i % 2 === 0 ? "lg:pr-16 lg:text-right" : "lg:ml-auto lg:pl-16"}`}
                data-testid={`timeline-item-${i}`}
              >
                <span className={`absolute top-1 w-3 h-3 bg-[#0A0A0A] -left-[38px] lg:left-auto ${i % 2 === 0 ? "lg:-right-[6.5px]" : "lg:-left-[6.5px]"}`} />
                <span className="font-display font-bold tracking-tighter text-5xl lg:text-6xl block">{m.year}<span className="text-[#DB2777]">.</span></span>
                <span className="text-xs uppercase tracking-[0.25em] font-bold text-[#DB2777] block mt-2">{m.month}</span>
                <h3 className="font-display font-bold uppercase tracking-tight text-2xl mt-3">{m.title}</h3>
                <p className="text-base leading-relaxed text-black/60 mt-2 max-w-md lg:max-w-none">{m.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;
